import Typography from "Components/CommonComponents/Typography";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import "./index.css";
import cx from "classnames";
import { useEffect } from "react";
import { useState, useContext } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { UserInfoContext } from "Context/CommonContext";
import { CustomDropdownWithSelect } from "Components/CommonComponents/CustomDropdownWithSelect";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import { CORPORATE_BRANCH_CODE } from "utilFunctions/Constants/Constants";
import LeftArrow from "Assets/Icons/LeftArrow";
import useMasterContext from "Context/MasterContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import FilterIcon from "Assets/Icons/FilterIcon";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import useGlobalSearchContext from "Context/GlobalSearchContext";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
// import CrossIcon from "Assets/Icons/CrossIcon";
export interface selectInterface {
  label: any;
  key: any;
  value: any;
  region?: any;
  id?: any;
}
const ColStyled = styled<any>(Col)`
  display: flex;
  margin-left: 0px;
  flex-direction: ${(props: any) =>
    ["xl", "xxl"].includes(props.screen) ? "row" : "column"};
  padding-right: 0px;
  padding-left: 0px;
  justify-content: end;
`;
const CardBodyStyled = styled<any>(CardBody)`
  padding: ${(props: any) =>
    ["xl", "xxl"].includes(props.screen) ? "16px" : "12px"};
`;
export const nullOption = [{ label: "All", key: "all", value: null }];
type IBranchHealthFilter = {
  mode?: string;
  onSelectClickHandler?: any;
  region: any[];
  applyFilter: any;
  filterState: any;
  setFilterState: any;
  resetHandler: any;
};
const BranchHealthFilter = ({
  region,
  applyFilter,
  filterState,
  setFilterState,
  resetHandler,
}: IBranchHealthFilter) => {
  const navigate = useNavigate();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { masters } = useMasterContext();
  const { screen }: any = useWindowSize();
  const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  const [stream, setStream] = useState<selectInterface[]>(
    masters?.streams ? nullOption.concat(masters.streams) : []
  );
  const [classes, setClassess] = useState<selectInterface[]>(
    masters?.classes ? nullOption.concat(masters.classes) : []
  );
  const [isFilterApplied, setIsFilterApplied] = useState<any>(false);
  const preFilterStream =
    masters.streams && masters.streams[0] != undefined
      ? masters.streams[0]
      : null;
  const [branchOptions, setBranchOptions] = useState<any>([]);
  const [branches, setBranches] = useState<selectInterface[]>([]);
  const [isPaneOpen, setisPaneOpen] = useState<boolean>(false);
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Stream",
      nickName: "stream",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Class",
      nickName: "clazz",
      data: classes,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Region",
      nickName: "region",
      data: region,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Branch",
      nickName: "branchCode",
      data: branches,
      singleSelect: false,
      filterSelectedData: [],
    },
  ]);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Stream",
        nickName: "stream",
        data: masters?.streams,
        singleSelect: true,
        filterSelectedData: [filterState.stream] as any,
      },
      {
        name: "Class",
        nickName: "clazz",
        data: masters?.classes,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Region",
        nickName: "region",
        data: region,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Branch",
        nickName: "branchCode",
        data: nullOption.concat(masters?.branches),
        singleSelect: false,
        filterSelectedData: [],
      },
    ]);
  }, [masters?.streams, masters?.classes, masters?.branches]);
  useEffect(() => {
    setStream(userInfo?.userStreams as any);
  }, [userInfo, masters?.streams]);
  useEffect(() => {
    setClassess(masters?.classes);
  }, [masters?.classes]);
  useEffect(() => {
    setBranches(masters?.userAssignedBranches);
  }, [masters?.userAssignedBranches]);

  const handleAddFilterArrayList = (name: string, val: any) => {
    if (name === "region") {
      setFilterState((prevState: any) => ({
        ...prevState,
        branchCode: null,
        [name]: val,
      }));
    } else {
      setFilterState((prevState: any) => ({
        ...prevState,
        [name]: val,
      }));
    }
  };
  const userBranchArray: any = userInfo.branch.split(",").map(Number);
  const applyFilterHandler = () => {
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      obj[ele.nickName] = ele.singleSelect
        ? ele.filterSelectedData[0]
        : ele.filterSelectedData;
    });
    setFilterState(obj);
    applyFilter(obj);
    console.log(filterState, "applyFilterHandler");
  };
  const handleClearAllFilter = () => {
    const clearedFilter = {
      region: null,
      stream: null,
      clazz: null,
      branch: null,
    };
    setFilterState(clearedFilter);
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return { ...ele, filterSelectedData: [] };
      }
    );
    setBranchOptions([]);
    setfilterheadingListing(filterheadingListingArr);
    resetHandler && resetHandler();
    setIsFilterApplied(false);
  };
  const handleOptionForBranches = (regionIds: any) => {
    if (regionIds && masters && Array.isArray(masters?.userAssignedBranches)) {
      const filteredbranches: any = [];
      masters?.userAssignedBranches.forEach((item: any) => {
        if (item.region === regionIds) {
          filteredbranches.push(item);
        }
      });
      setBranchOptions(filteredbranches);
    }
  };

  const HandleApplyFilter = (filterState: any) => {
    applyFilter(filterState);
    setIsFilterApplied(true);
  };
  //   useEffect(() => {
  //     const filterLength = Object.values(filterState).filter(
  //       (ele) => ele != null
  //     ).length;
  //     console.log("filterState=====", filterState, filterLength);
  //   }, [filterState]);
  const isBranchDisabled = userBranchArray.includes(CORPORATE_BRANCH_CODE)
    ? false
    : true;
  const filterStateCopy = { ...filterState };
  if (preFilterStream?.label == filterStateCopy?.stream?.label) {
    delete filterStateCopy["stream"];
  }
  const filterLength = Object.values(filterStateCopy).filter(
    (ele: any) => ele != null
  ).length;
  return (
    <div className="pl-5 pr-3">
      {["xs", "sm", "md"].includes(screen) && (
        <FilterSliderComponent
          width={"100%"}
          isPaneOpen={globalSearchData?.isBranchHealth}
          setisPaneOpen={() => {
            saveGlobalSearchData({
              pathurl: null,
              isBranchHealth: false,
              isStudentHealth: false,
            });
          }}
          hideHeader={true}
          filterState={filterState}
          filterheadingListing={
            isBranchDisabled
              ? filterheadingListing.filter((ele) => ele.name != "Branch")
              : filterheadingListing
          }
          setfilterheadingListing={setfilterheadingListing}
          applyFilterHandler={applyFilterHandler}
        ></FilterSliderComponent>
      )}

      {["xxl", "xl", "lg"].includes(screen) && (
        <Card className="w-100 mt-3 branchHealthFilterCard mb-0">
          <CardBodyStyled screen={screen}>
            <CardTitle tag="h5" className="titleBar mb-0">
              <Row className="rowMain d-flex align-items-center mb-0">
                <Col
                  xxl="4"
                  xl="4"
                  lg="2"
                  md="4"
                  sm="6"
                  xs="6"
                  className="d-flex flex-row p-0 align-items-center"
                >
                  <LeftArrow
                    className={"cursorHoverCSS mr-3"}
                    onClick={() => {
                      if (userInfo.fexRole == UserRoles?.academicCounsellor) {
                        navigate("/admin/myBranch", {
                          replace: true,
                          state: {
                            selectedStudent: null,
                          },
                        });
                      } else {
                        navigate("/admin/dashboard", {
                          replace: true,
                          state: {
                            selectedStudent: null,
                          },
                        });
                      }
                    }}
                  />

                  <Typography
                    variant={["xxl", "xl"].includes(screen) ? "h4" : "h6"}
                    color="black"
                  >
                    Left Out Probability
                  </Typography>
                </Col>
                {["xxl", "xl", "lg"].includes(screen) ? (
                  <ColStyled
                    screen={screen}
                    xxl="8"
                    xl="8"
                    lg="10"
                    md="8"
                    sm="6"
                    xs="6"
                  >
                    <Row className="w-100 d-flex flex-row justify-content-end align-items-center">
                      <Col
                        xxl="2"
                        xl="2"
                        lg="2"
                        md="3"
                        sm="12"
                        xs="12"
                        className="pl-2 pr-2"
                      >
                        <CustomSelect
                          isSelected={filterState.stream != null ? true : false}
                          width={"100%"}
                          top={"-3px"}
                          placeholder="Stream"
                          options={stream}
                          isSearchable={false}
                          menuPlacement="bottom"
                          isClearable={false}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={true}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("stream", selected);
                          }}
                          value={filterState.stream}
                        />
                      </Col>
                      <Col
                        xxl="2"
                        xl="2"
                        lg="2"
                        md="3"
                        sm="12"
                        xs="12"
                        className="pl-2 pr-2"
                      >
                        <CustomSelect
                          isSelected={filterState.clazz != null ? true : false}
                          width={"100%"}
                          top={"-3px"}
                          placeholder="Class"
                          options={classes}
                          isSearchable={false}
                          menuPlacement="bottom"
                          isClearable={false}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={true}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("clazz", selected);
                          }}
                          value={filterState.clazz}
                        />
                      </Col>
                      <Col
                        xxl="2"
                        xl="2"
                        lg="2"
                        md="3"
                        sm="12"
                        xs="12"
                        className="pl-2 pr-2"
                      >
                        <CustomSelect
                          isSelected={filterState.region != null ? true : false}
                          width={"100%"}
                          top={"-3px"}
                          placeholder="Region"
                          options={region}
                          isSearchable={false}
                          menuPlacement="bottom"
                          isClearable={false}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={true}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("region", selected);
                            const regionIds = selected.id;
                            setBranchOptions([]);
                            handleOptionForBranches(regionIds);
                          }}
                          value={filterState.region}
                        />
                      </Col>
                      <Col
                        xxl={filterLength != 0 && isFilterApplied ? "4" : "4"}
                        xl={filterLength != 0 && isFilterApplied ? "4" : "4"}
                        lg={filterLength != 0 && isFilterApplied ? "4" : "4"}
                        md="3"
                        sm="12"
                        xs="12"
                        className="d-flex flex-row pl-2 pr-2"
                      >
                        <CustomDropdownWithSelect
                          isDisabled={branchOptions.length > 0 ? false : true}
                          isSelected={false}
                          placeholderLabel="Branch"
                          width={"100%"}
                          isInPerformance={true}
                          options={branchOptions}
                          menuPlacement="bottom"
                          isClearable={false}
                          isSearchable={true}
                          isMulti={true}
                          isSearchableDrop={true}
                          isDropdownSelect={true}
                          top={"0px"}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("branchCode", selected);
                          }}
                          showClearIcon={
                            userBranchArray.includes(CORPORATE_BRANCH_CODE)
                              ? false
                              : false
                          }
                          value={filterState.branchCode}
                        />
                      </Col>

                      <Col
                        xxl={filterLength != 0 && isFilterApplied ? "2" : "1"}
                        xl={filterLength != 0 && isFilterApplied ? "2" : "1"}
                        lg={filterLength != 0 && isFilterApplied ? "2" : "1"}
                        md="3"
                        sm="12"
                        xs="12"
                        className="d-flex flex-row justify-content-evenly pl-1 pr-1"
                      >
                        {" "}
                        <Button
                          size="sm"
                          color="aeslPrimary"
                          onClick={() => {
                            HandleApplyFilter(filterState);
                          }}
                          className="m-0"
                        >
                          Apply
                        </Button>
                        {filterLength != 0 && isFilterApplied && (
                          <div
                            onClick={() => {
                              if (filterLength != 0) {
                                handleClearAllFilter();
                              }
                            }}
                            className="d-flex justify-content-center align-items-center cursor-pointer"
                          >
                            <span
                              className={cx("filterSpan", "filterspanWidth", {
                                resetAllButtonStyle:
                                  filterLength != 0 && isFilterApplied,
                              })}
                            >
                              Reset All{" "}
                            </span>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </ColStyled>
                ) : (
                  <Col
                    xxl="6"
                    xl="6"
                    lg="6"
                    md="6"
                    sm="6"
                    xs="6"
                    className="d-flex justify-content-end p-0"
                  >
                    {filterLength != 0 ? (
                      <div className="d-flex">
                        <div
                          className="clearAllButtonStyle cursorHoverCSS"
                          onClick={() => {
                            handleClearAllFilter();
                          }}
                        >
                          Clear All
                        </div>
                        <FilterIcon
                          onClick={() => {
                            setisPaneOpen(!isPaneOpen);
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center"
                        onClick={() => {
                          setisPaneOpen(!isPaneOpen);
                        }}
                      >
                        <span className="filterSpan">Filter</span>
                        <FilterIcon />
                      </div>
                    )}
                    {filterLength != 0 ? (
                      <div className="filterButtonTipMB">{filterLength}</div>
                    ) : null}
                  </Col>
                )}
              </Row>
            </CardTitle>
          </CardBodyStyled>
        </Card>
      )}
    </div>
  );
};
export default BranchHealthFilter;
